<script setup lang="ts">

import { RouteLocationRaw, useRoute } from "vue-router";
import { ref, watch } from "vue";

import { getRouteXAccountsCard } from "../views/Auth/accounts/Cards.vue";
import { getRouteXAccountsCrypto } from "../views/Auth/accounts/Crypto.vue";
import { getRouteXAccountsFiat } from "../views/Auth/accounts/Fiat.vue";
import { getRouteXDashboard } from "../views/Auth/Dashboard.vue";

type IMenuItem = {
  title: string;
  src: RouteLocationRaw;
};
const menu: IMenuItem[] = [
  { title: "Dashboard", src: getRouteXDashboard() },
  { title: "Cash Accounts", src: getRouteXAccountsFiat() },
  { title: "Crypto Wallets", src: getRouteXAccountsCrypto() },
  { title: "Cards", src: getRouteXAccountsCard() }
];

const route = useRoute();

const currentRoute = ref(route.name);
watch(
  () => route.name,
  (src) => (currentRoute.value = src)
);


</script>

<template>
  <RouterLink
    :to="menuItem.src"
    v-for="menuItem of menu"
    class="router-link px-3 py-2 transition-colors hover:text-[var(--m-primary-base)]"
    :class="(menuItem.src as any).name == currentRoute ? 'text-[var(--m-primary-base)] border-b-2 border-[var(--m-primary-base)]' : 'text-gray-700 dark:text-gray-300'"
  >
    {{ menuItem.title }}
  </RouterLink>
</template>

<style scoped lang="scss">
.router-link {
  display: inline-block;
}
</style>
